import React from "react"

const ScreenResizeIcon = ({ size, color }) => {
  return (
    <svg
      width={size || "27"}
      height={size || "28"}
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="25.75"
        y1="3.27827e-08"
        x2="25.75"
        y2="28"
        stroke={color || "#B5B7C5"}
        strokeWidth="1.5"
      />
      <path
        d="M0.469669 13.4697C0.176777 13.7626 0.176777 14.2374 0.469669 14.5303L5.24264 19.3033C5.53553 19.5962 6.01041 19.5962 6.3033 19.3033C6.59619 19.0104 6.59619 18.5355 6.3033 18.2426L2.06066 14L6.3033 9.75736C6.59619 9.46447 6.59619 8.98959 6.3033 8.6967C6.01041 8.40381 5.53553 8.40381 5.24264 8.6967L0.469669 13.4697ZM17 13.25L1 13.25V14.75L17 14.75V13.25Z"
        fill={color || "#B5B7C5"}
      />
    </svg>
  )
}

export default ScreenResizeIcon
